<template>
  <div class="del-layout h-100">
    <router-view />
  </div>
</template>

<style lang="scss"></style>
